import watch from 'redux-watch';

class MapCtrl {
    constructor($scope, $timeout, $element, $location, mapServ, mapHelperServ, storeServ, shopTypesServ) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$element = $element;
        this.$location = $location;
        this.mapServ = mapServ;
        this.mapHelperServ = mapHelperServ;
        this.storeServ = storeServ;
        this.shopTypesServ = shopTypesServ;

        this.openShopDetailsUrlInNewWindow = $scope.$eval($scope.openShopDetailsUrlInNewWindow);

        this.mapOptions = this.mapServ.readMapOptions();
        this.markerOptions = this.mapServ.readMarkerOptions();
        this.markerClustererOptions = this.mapServ.readMarkerClustererOptions();

        this.highlightShopOnMapByPosFromUrl = !!this.$location.search().pos;

        this.initMap();

        this.setMapStyles();

        this.initMarkerClusterer();

        this.initDirectionsService();

        this.initDirectionsDisplay();

        this.subscribeToStore();

        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    /**
     *  Init.
     */

    initMap() {
        this.map = new google.maps.Map(this.$element.find('#map-canvas')[0], {
            center: {
                lat: this.mapOptions.lat,
                lng: this.mapOptions.lng
            },
            zoom: this.mapOptions.zoom,
            styles: this.mapOptions.styles,
            streetViewControl: false,
            mapTypeControl: false
        });
    }

    setMapStyles() {
        const customMapType = new google.maps.StyledMapType([{
            elementType: 'all',
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
        }], {
            name: 'Orange Shops Styles'
        });

        const customMapTypeId = 'orangeShops';

        this.map.mapTypes.set(customMapTypeId, customMapType);
        this.map.setMapTypeId(customMapTypeId);
    }

    initMarkerClusterer() {
        this.markerClusterer = new MarkerClusterer(this.map, [], this.markerClustererOptions);
    }

    initDirectionsService() {
        this.directionsService = new google.maps.DirectionsService();
    }

    initDirectionsDisplay() {
        this.directionsDisplay = new google.maps.DirectionsRenderer();

        this.directionsDisplay.setOptions({
            'preserveViewport': true,
            'suppressMarkers': true
        });

        this.directionsDisplay.setMap(this.map);
    }

    subscribeToStore() {
        let watchShopType = watch(this.storeServ.getState, 'shopType');
        let watchSearchedPlaceCoordinates = watch(this.storeServ.getState, 'searchedPlaceCoordinates');
        let watchClickedMarkerCoordinates = watch(this.storeServ.getState, 'setClickedShopMarkerCoordinates');
        let watchToggleInfoWindow = watch(this.storeServ.getState, 'toggleInfoWindow');

        this.stopWatchingShopType = this.storeServ.subscribe(watchShopType((newVal, oldVal, objectPath) => {
            this.shopType = newVal;
        }));

        this.stopWatchingSearchedPlaceCoordinates = this.storeServ.subscribe(watchSearchedPlaceCoordinates((newVal, oldVal, objectPath) => {
            this.searchedPlaceCoordinates = newVal;
        }));

        this.stopWatchingClickedMarkerCoordinates = this.storeServ.subscribe(watchClickedMarkerCoordinates((newVal, oldVal, objectPath) => {
            this.clickedMarkerCoordinates = newVal;
        }));

        this.stopWatchingToggleInfoWindow = this.storeServ.subscribe(watchToggleInfoWindow((newVal, oldVal, objectPath) => {
            this.toggleInfoWindow = newVal;
        }));
    }

    /**
     *  Listeners.
     */

    ngOnDestroy() {
        this.stopWatchingShopType();
        this.stopWatchingSearchedPlaceCoordinates();
        this.stopWatchingClickedMarkerCoordinates();
        this.stopWatchingToggleInfoWindow();
    }
}

MapCtrl.$inject = ['$scope', '$timeout', '$element', '$location', 'mapServ', 'mapHelperServ', 'storeServ', 'shopTypesServ'];

export default MapCtrl;
